// HDSRのReducer
import * as HDSR from '../../constants/HDSR';

const initialState = {
  Loading: false,
  Loaded: false,
};

export function hdsr(state: any = initialState, action: any) {
  switch (action.type) {
    case HDSR.SUCCESS:
      return Object.assign({}, state, {
        Loading: false,
        Loaded: true,
        result: action.result,
      });
    case HDSR.ERROR:
      return Object.assign({}, state, {
        Loading: false,
        Loaded: true,
        result: action.result,
      });
    case HDSR.LOADING:
      return Object.assign({}, state, {
        Loading: true,
        Loaded: false,
      });
    case HDSR.INITIALIZE:
      return Object.assign({}, state, {
        Loading: false,
        Loaded: false,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/HDSR.tsx